// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { PageInfoFragment } from '../../../../../graphql/fragments/pageInfo.fragment.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../../../graphql/fragments/pageInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TasksTableTasks_TaskFragment = { __typename?: 'EntityTask', id: string, dueAt: Time, type: Types.EntityTaskType, title: string, assignedTo?: { __typename?: 'User', id: string, displayName: string } | null, entity: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string }, household: { __typename?: 'Household', id: string, displayName: string, subBrand?: { __typename?: 'SubBrand', id: string, displayName: string } | null } } };

export type GetTasksTableTasksQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.EntityTaskWhereInput>;
  orderBy?: Types.InputMaybe<Array<Types.EntityTaskOrder> | Types.EntityTaskOrder>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type GetTasksTableTasksQuery = { __typename?: 'Query', paginatedData: { __typename?: 'EntityTaskConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'EntityTaskEdge', node?: (
        { __typename?: 'EntityTask', id: string }
        & TasksTableTasks_TaskFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetTasksTableTasks: 'GetTasksTableTasks' as const
  },
  Fragment: {
    TasksTableTasks_Task: 'TasksTableTasks_Task' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TasksTableTasks_TaskFragmentDoc = gql`
    fragment TasksTableTasks_Task on EntityTask {
  id
  dueAt
  type
  title
  assignedTo {
    id
    displayName
  }
  entity {
    id
    subtype {
      id
      displayName
    }
    household {
      id
      displayName
      subBrand {
        id
        displayName
      }
    }
  }
}
    `;
export const GetTasksTableTasksDocument = gql`
    query GetTasksTableTasks($where: EntityTaskWhereInput, $orderBy: [EntityTaskOrder!], $first: Int!, $after: Cursor) {
  paginatedData: entityTasks(
    where: $where
    orderBy: $orderBy
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        ...TasksTableTasks_Task
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${TasksTableTasks_TaskFragmentDoc}`;

/**
 * __useGetTasksTableTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksTableTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksTableTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksTableTasksQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetTasksTableTasksQuery(baseOptions: Apollo.QueryHookOptions<GetTasksTableTasksQuery, GetTasksTableTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksTableTasksQuery, GetTasksTableTasksQueryVariables>(GetTasksTableTasksDocument, withFetchPolicyContext(options));
      }
export function useGetTasksTableTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksTableTasksQuery, GetTasksTableTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksTableTasksQuery, GetTasksTableTasksQueryVariables>(GetTasksTableTasksDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetTasksTableTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksTableTasksQuery, GetTasksTableTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksTableTasksQuery, GetTasksTableTasksQueryVariables>(GetTasksTableTasksDocument, withFetchPolicyContext(options));
        }
export type GetTasksTableTasksQueryHookResult = ReturnType<typeof useGetTasksTableTasksQuery>;
export type GetTasksTableTasksLazyQueryHookResult = ReturnType<typeof useGetTasksTableTasksLazyQuery>;
export type GetTasksTableTasksSuspenseQueryHookResult = ReturnType<typeof useGetTasksTableTasksSuspenseQuery>;
export type GetTasksTableTasksQueryResult = Apollo.QueryResult<GetTasksTableTasksQuery, GetTasksTableTasksQueryVariables>;